import { render, staticRenderFns } from "./basic-details.vue?vue&type=template&id=12ef975a"
import script from "./basic-details.vue?vue&type=script&lang=js"
export * from "./basic-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports